module.exports = __webpack_public_path__ + "staticVue/img/1.a80c6358.png";